import type { IUserProfile } from 'src/types/user';

export function hasFullOrgAccess(userProfile: IUserProfile | null | undefined, orgGuid?: string) {
  if (!userProfile || !orgGuid) {
    return false;
  }

  return Boolean(userProfile.employerOrgs?.some((org) => org.guid === orgGuid));
}

/** True when the user is a super user or has beta access. */
export function hasSuperUserOrBetaAccess(userProfile: IUserProfile | null | undefined): boolean {
  return Boolean(userProfile?.isSuperUser || userProfile?.hasBetaAccess);
}

/** True only when the user is a super user (no beta-access fallback). */
export function isSuperUser(userProfile: IUserProfile | null | undefined): boolean {
  return Boolean(userProfile?.isSuperUser);
}

